// Bilingual (IT/EN) dictionary
export const translations = {
  it: {
    app_name: "Sicurgarda Scadenze",
    tagline: "Centro operativo per scadenze, documenti e attestati",
    login: "Accedi",
    logout: "Esci",
    email: "Email",
    password: "Password",
    login_cta: "Entra nel sistema",
    invalid_credentials: "Credenziali non valide",
    dashboard: "Dashboard",
    companies: "Aziende",
    workers: "Lavoratori",
    deadlines: "Scadenze",
    attestati: "Import attestati",
    documents: "Documenti",
    dvr: "Redazione DVR",
    certificates: "Attestati",
    courses: "Corsi",
    course_date_start: "Data corso (inizio)",
    course_date_end: "Data corso (fine)",
    users: "Utenti",
    templates: "Modelli attestati",
    signatures: "Firme grafiche",
    nominations: "Lettere di Nomina",
    add_template: "Nuovo modello",
    template_name: "Nome modello",
    template_title: "Titolo attestato",
    template_body: "Corpo attestato (con campi dinamici)",
    normative_text: "Testo normativo",
    footer_text: "Testo piè di pagina",
    set_default: "Imposta come predefinito",
    notifications: "Notifiche",
    settings: "Impostazioni",
    upcoming_deadlines: "Scadenze imminenti",
    total_companies: "Aziende clienti",
    total_workers: "Lavoratori",
    total_certificates: "Attestati emessi",
    total_deadlines: "Scadenze totali",
    add_company: "Nuova azienda",
    add_worker: "Nuovo lavoratore",
    add_deadline: "Nuova scadenza",
    generate_certificate: "Genera attestato",
    upload_document: "Carica documento",
    company_name: "Ragione sociale",
    vat_number: "Partita IVA",
    tax_code: "Codice fiscale",
    address: "Indirizzo",
    phone: "Telefono",
    referent: "Referente",
    first_name: "Nome",
    last_name: "Cognome",
    role: "Mansione",
    department: "Reparto",
    category: "Categoria",
    title: "Titolo",
    due_date: "Data scadenza",
    description: "Descrizione",
    status: "Stato",
    actions: "Azioni",
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    search: "Cerca…",
    all: "Tutti",
    formazione: "Formazione",
    sanitaria: "Sanitaria",
    documentale: "Documentale",
    impianti: "Impianti",
    analisi: "Analisi",
    consulenza: "Consulenza",
    status_ok: "OK",
    status_warning: "Attenzione",
    status_critical: "Critica",
    status_expired: "Scaduta",
    status_completed: "Completata",
    status_no_term: "Senza termine",
    no_data: "Nessun dato",
    loading: "Caricamento…",
    course_title: "Titolo corso",
    course_hours: "Ore",
    course_topics: "Argomenti",
    trainer: "Docente",
    tutor: "Tutor",
    training_body: "Soggetto formatore",
    issue_date: "Data emissione",
    expiry_date: "Scadenza attestato",
    download: "Scarica",
    number: "Numero",
    file: "File",
    drop_here: "Trascina qui il file o clicca per selezionare",
    run_reminders: "Invia promemoria",
    reminders_sent: "Promemoria inviati",
    import_excel: "Importa Excel",
    download_template: "Scarica template",
    imported: "Righe importate",
    mark_complete: "Segna completata",
    company: "Azienda",
    worker: "Lavoratore",
    optional: "opzionale",
    days_left: "giorni",
    expired_by: "scaduta da",
    welcome: "Benvenuto",
    hello: "Ciao",
    my_dashboard: "La mia dashboard",
    company_isolated: "I dati sono isolati per azienda cliente.",
    logo_url: "URL logo",
    active: "Attivo",
    forgot_password: "Password dimenticata?",
    forgot_password_title: "Recupera password",
    forgot_password_sub: "Inserisci la tua email: ti invieremo un link per reimpostare la password.",
    reset_password_title: "Reimposta password",
    check_your_inbox: "Controlla la tua casella email",
    new_password: "Nuova password",
    confirm_password: "Conferma password",
    current_password: "Password attuale",
    change_password: "Cambia password",
    create_account: "Crea un account",
    create_account_sub: "Registra la tua organizzazione e inizia gratis.",
    full_name: "Nome e cognome",
    organization: "Organizzazione",
    sign_up_cta: "Crea account",
    sign_up: "Registrati",
    no_account: "Non hai un account?",
    already_have_account: "Hai già un account?",
    back_to_login: "Torna al login",
    reset_link_sent: "Se l'email è registrata riceverai un link di reset entro pochi minuti.",
    email_recipient: "Email destinatario",
    add_user: "Nuovo utente",
    role_super_admin: "Super Admin",
    role_operatore: "Operatore",
    role_cliente: "Cliente",
    global_search: "Ricerca globale",
    view: "Vedi",
  },
  en: {
    app_name: "Sicurgarda Deadlines",
    tagline: "Operations hub for deadlines, documents & certificates",
    login: "Sign in",
    logout: "Log out",
    email: "Email",
    password: "Password",
    login_cta: "Enter system",
    invalid_credentials: "Invalid credentials",
    dashboard: "Dashboard",
    companies: "Companies",
    workers: "Workers",
    deadlines: "Deadlines",
    attestati: "Import certificates",
    documents: "Documents",
    dvr: "DVR Redaction",
    certificates: "Certificates",
    courses: "Courses",
    course_date_start: "Course date (start)",
    course_date_end: "Course date (end)",
    users: "Users",
    templates: "Certificate templates",
    signatures: "Signatures",
    nominations: "Nomination Letters",
    add_template: "New template",
    template_name: "Template name",
    template_title: "Certificate title",
    template_body: "Certificate body (with dynamic fields)",
    normative_text: "Normative text",
    footer_text: "Footer text",
    set_default: "Set as default",
    notifications: "Notifications",
    settings: "Settings",
    upcoming_deadlines: "Upcoming deadlines",
    total_companies: "Client companies",
    total_workers: "Workers",
    total_certificates: "Issued certificates",
    total_deadlines: "Total deadlines",
    add_company: "New company",
    add_worker: "New worker",
    add_deadline: "New deadline",
    generate_certificate: "Generate certificate",
    upload_document: "Upload document",
    company_name: "Company name",
    vat_number: "VAT number",
    tax_code: "Tax code",
    address: "Address",
    phone: "Phone",
    referent: "Contact person",
    first_name: "First name",
    last_name: "Last name",
    role: "Role",
    department: "Department",
    category: "Category",
    title: "Title",
    due_date: "Due date",
    description: "Description",
    status: "Status",
    actions: "Actions",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    edit: "Edit",
    search: "Search…",
    all: "All",
    formazione: "Training",
    sanitaria: "Medical",
    documentale: "Documents",
    impianti: "Plants",
    analisi: "Analysis",
    consulenza: "Consulting",
    status_ok: "OK",
    status_warning: "Warning",
    status_critical: "Critical",
    status_expired: "Expired",
    status_completed: "Completed",
    status_no_term: "No term",
    no_data: "No data",
    loading: "Loading…",
    course_title: "Course title",
    course_hours: "Hours",
    course_topics: "Topics",
    trainer: "Trainer",
    tutor: "Tutor",
    training_body: "Training body",
    issue_date: "Issue date",
    expiry_date: "Certificate expiry",
    download: "Download",
    number: "Number",
    file: "File",
    drop_here: "Drop file here or click to select",
    run_reminders: "Send reminders",
    reminders_sent: "Reminders sent",
    import_excel: "Import Excel",
    download_template: "Download template",
    imported: "Rows imported",
    mark_complete: "Mark complete",
    company: "Company",
    worker: "Worker",
    optional: "optional",
    days_left: "days",
    expired_by: "expired by",
    welcome: "Welcome",
    hello: "Hello",
    my_dashboard: "My dashboard",
    company_isolated: "Data is isolated per client company.",
    logo_url: "Logo URL",
    active: "Active",
    forgot_password: "Forgot password?",
    forgot_password_title: "Recover password",
    forgot_password_sub: "Enter your email — we'll send a reset link.",
    reset_password_title: "Reset password",
    check_your_inbox: "Check your inbox",
    new_password: "New password",
    confirm_password: "Confirm password",
    current_password: "Current password",
    change_password: "Change password",
    create_account: "Create account",
    create_account_sub: "Register your organization — free to start.",
    full_name: "Full name",
    organization: "Organization",
    sign_up_cta: "Create account",
    sign_up: "Sign up",
    no_account: "Don't have an account?",
    already_have_account: "Already have an account?",
    back_to_login: "Back to login",
    reset_link_sent: "If the email is registered you'll receive a reset link within a few minutes.",
    email_recipient: "Recipient email",
    add_user: "New user",
    role_super_admin: "Super Admin",
    role_operatore: "Operator",
    role_cliente: "Client",
    global_search: "Global search",
    view: "View",
  },
};
